import React, { useState } from "react";
import { Box, Typography, Button, Chip } from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import api from "../../api/axios";

const AgentSponsorshipCard = ({
  sponsorshipStatus = "NONE",
  agentId,
  onApplied
}) => {
  const [loading, setLoading] = useState(false);

  const handleApply = async () => {
    try {
      setLoading(true);
      // Using the same flow as vendor: apply for sponsorship
      await api.post(`/agent/${agentId}/apply-sponsorship`, { plan: "30_DAYS" });
      onApplied?.();
    } catch (err) {
      console.error("Sponsorship application failed:", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ ACTIVE → Sponsored badge
  if (sponsorshipStatus === "ACTIVE") {
    return (
      <Chip
        icon={<WorkspacePremiumIcon />}
        label="Sponsored Agent"
        sx={{
          bgcolor: "#fff4e5",
          color: "#b26a00",
          fontWeight: 600,
          fontSize: 12
        }}
      />
    );
  }

  // ✅ PENDING → Under Review
  if (sponsorshipStatus === "PENDING") {
    return (
      <Chip
        icon={<HourglassEmptyIcon />}
        label="Under Review"
        sx={{
          bgcolor: "#e3f2fd",
          color: "#1565c0",
          fontWeight: 600,
          fontSize: 12
        }}
      />
    );
  }

  // ✅ NONE or EXPIRED → Apply Button
  return (
    <Button 
      variant="outlined" 
      size="small" 
      onClick={handleApply} 
      disabled={loading}
      sx={{ 
        ml: 2, 
        textTransform: 'none', 
        fontSize: 12,
        borderColor: '#b26a00',
        color: '#b26a00',
        '&:hover': { borderColor: '#8a5400', bgcolor: '#fff4e5' }
      }}
    >
      {loading ? "Applying..." : "Apply for Sponsorship"}
    </Button>
  );
};

export default AgentSponsorshipCard;
